import { render, staticRenderFns } from "./domain-notes.vue?vue&type=template&id=6bbdec0a&scoped=true"
import script from "./domain-notes.vue?vue&type=script&lang=js"
export * from "./domain-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbdec0a",
  null
  
)

export default component.exports